import {Component, EventEmitter, Input, Output} from '@angular/core';
import { CommonModule } from '@angular/common';
import {BsModalRef} from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-dialog-header',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './dialog-header.component.html',
  styleUrls: ['./dialog-header.component.scss']
})
export class DialogHeaderComponent {
  @Input() title: string;
  @Input() close: boolean = true;
  @Output() closed: EventEmitter<void> = new EventEmitter<void>();

  constructor(
    public bsModalRef: BsModalRef
  ) {
  }
}
